import React from "react";
import ReactDOM from "react-dom";
import AuthContextProvider from "./context/auth-context";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { initConsoleCapture } from "./middleware/consoleCapture";

initConsoleCapture();

const app = (
  <AuthContextProvider>
    <App />
  </AuthContextProvider>
);

Sentry.init({
  dsn: "https://70c77e35d73d4090812ec61ff57892ee@o275179.ingest.sentry.io/5747982",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: process.env.REACT_APP_PROD === "true" ? 0.5 : 0,
});
ReactDOM.render(app, document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
